(function () {
  if (typeof document === 'undefined') return;

  var FORM_ID    = 'ContactForm';
  var CONSENT_ID = 'ContactForm-marketing';
  /* Mailchimp answers this endpoint in roughly 0.6-0.7s, so 1.5s left almost
     no margin: a slower reply meant the fallback fired, the enquiry went
     through and the subscribe was dropped with nothing logged. */
  var TIMEOUT_MS = 5000;
  var MSG_MAX    = 255;

  var FIELDS = {
    EMAIL:    'ContactForm-email',
    FNAME:    'ContactForm-first-name',
    LNAME:    'ContactForm-last-name',
    PHONE:    'ContactForm-phone',
    MMERGE17: 'ContactForm-topic',
    MMERGE16: 'ContactForm-order-number',
    MMERGE14: 'ContactForm-body'
  };

  var read = function (form, id) {
    var el = form.querySelector('#' + id);
    return (el && el.value) ? el.value.trim() : '';
  };

  var initForm = function (form) {
    if (form.dataset.mcBound === '1') return;
    form.dataset.mcBound = '1';

    var endpoint = form.dataset.mcEndpoint;
    var u        = form.dataset.mcU;
    var id       = form.dataset.mcId;
    var fid      = form.dataset.mcFid;

    if (!endpoint || !u || !id) {
      console.warn('[Mailchimp] Not configured - endpoint, u or id is empty. Nothing will be subscribed.');
      return;
    }

    /* Mailchimp names its bot trap after the audience, so it has to be built
       from the settings rather than hardcoded, or it goes stale the moment
       the merchant points the form at a different list. */
    var honeypot = 'b_' + u + '_' + id;

    /* The checkbox only exists while the section's consent label is filled
       in, and it gates the subscribe — so an empty label silently turns the
       whole integration off. Say so once, at bind time. */
    if (!form.querySelector('#' + CONSENT_ID)) {
      console.warn('[Mailchimp] No consent checkbox on this form - the consent label in the contact section is empty, so nothing can be subscribed.');
    }

    form.addEventListener('submit', function handler(e) {
      var email = read(form, FIELDS.EMAIL);
      if (!email) return; // let Shopify handle empty email validation

      /* Ticked means opted in, and only an opt-in can be recorded from here:
         the storefront customer endpoint always sets accepts_marketing = true
         and Mailchimp's embedded endpoint only subscribes, so neither system
         can be told "not subscribed" from theme code. Unticked therefore
         sends nothing to either - the enquiry email still goes out, and
         returning without preventDefault lets Shopify submit it.

         Showing an unticked enquiry as Non-subscribed needs a server-side
         call (Shopify Admin API, or Mailchimp's API with transactional
         status), which is outside what a theme can do. */
      var consent = form.querySelector('#' + CONSENT_ID);
      var consented = !!(consent && consent.checked);
      if (!consented) {
        console.info('[Mailchimp] Consent not given - enquiry sent, no marketing record created.');
        return;
      }

      e.preventDefault(); // hold navigation

      if (form.dataset.mcSending === '1') return;
      form.dataset.mcSending = '1';

      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.mcOrigText = btn.textContent; btn.textContent = 'Sending...'; }

      var cbName = 'mcCb_' + Date.now();
      var params = new URLSearchParams();

      params.set('u', u);
      params.set('id', id);
      if (fid) params.set('f_id', fid);
      params.set('c', cbName);

      Object.keys(FIELDS).forEach(function (tag) {
        var val = read(form, FIELDS[tag]);
        if (tag === 'MMERGE14') val = val.slice(0, MSG_MAX);
        params.set(tag, val);
      });

      params.set(honeypot, '');

      /* Shopify keeps a contact-form enquiry only as an email, so storing the
         person needs a second post to the customer endpoint - the same one the
         newsletter form uses. keepalive lets it outlive the navigation that
         proceed() triggers a moment later.

         Shopify sets accepts_marketing = true on every customer created this
         way; no storefront call stores one without it. The consent answer goes
         into the tags so an unticked enquiry can still be told apart. */
      var storeInShopify = function () {
        var body = new URLSearchParams();
        body.set('form_type', 'customer');
        body.set('utf8', '✓');
        body.set('contact[email]', email);
        body.set('contact[first_name]', read(form, FIELDS.FNAME));
        body.set('contact[last_name]', read(form, FIELDS.LNAME));
        body.set('contact[tags]', 'contact-form,consent-yes');

        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString(),
          keepalive: true
        })
          .then(function (res) { console.info('[Shopify] Customer post returned', res.status); })
          .catch(function (err) { console.warn('[Shopify] Customer post failed:', err && err.message); });
      };

      storeInShopify();

      var script   = document.createElement('script');
      var timer    = null;
      var finished = false;

      var proceed = function () {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        delete window[cbName];
        if (script.parentNode) script.parentNode.removeChild(script);
        delete form.dataset.mcSending;
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.mcOrigText || btn.textContent; }
        // Remove listener BEFORE submit to prevent re-entry
        form.removeEventListener('submit', handler);
        /* requestSubmit() fires the submit event and then navigates, so
           Shopify's captcha — which hooks that event to attach its token —
           still runs. form.submit() skips the event entirely. */
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      };

      window[cbName] = function (data) {
        if (data && data.result === 'error') {
          console.warn('[Mailchimp] Subscription error:', data.msg);
        } else {
          console.info('[Mailchimp] Subscribed:', (data && data.msg) || 'ok');
        }
        if (!finished) proceed();
      };

      /* Both of these used to be silent, which is why a failed subscribe
         looked identical to a working one. */
      script.onerror = function () {
        console.warn('[Mailchimp] Request blocked or failed to load:', script.src);
        proceed();
      };
      timer = setTimeout(function () {
        if (!finished) console.warn('[Mailchimp] No reply within ' + TIMEOUT_MS + 'ms - subscribe dropped, enquiry still sent.');
        proceed();
      }, TIMEOUT_MS); // fallback — never block the enquiry

      script.type = 'text/javascript';
      script.async = true;
      script.src = endpoint + '?' + params.toString();
      document.body.appendChild(script);
    });
  };

  var bind = function (root) {
    var scope = root || document;
    var form = scope.querySelector ? scope.querySelector('#' + FORM_ID) : null;
    if (form) initForm(form);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target);
  });
})();
